import { AppButton, AppDialog, FormField } from "../../components/ui";
import { FormControlLabel, Checkbox } from "@mui/material";
import { ClioTasksInfo, UsersModel } from "../../api";
import { useEffect, useState } from "react";
import { ClioTaskAssigneeSelect } from "../../components/shared/ClioSelects";

interface ClioTaskInfoDialogProps {
  task: ClioTasksInfo;
  onClose: () => void;
  onSave: (updatedTask: ClioTasksInfo) => void;
  users?: UsersModel[];
}

export default function ClioTaskInfoDialog({
  task,
  onClose,
  onSave,
  users,
}: ClioTaskInfoDialogProps) {
  const [formTask, setFormTask] = useState<ClioTasksInfo>(task);

  useEffect(() => {
    setFormTask(task);
  }, [task])

  const handleChange = (field: keyof ClioTasksInfo, value: any) => {
    setFormTask((prev) => (prev ? { ...prev, [field]: value } : prev));
  };

  const handleSave = () => {
    onSave(formTask)
  }

  return (
    <AppDialog
      open={!!formTask}
      onClose={onClose}
      maxWidth="md"
      title={`Edit Task #${formTask.id}`}
      contentDividers
      actions={
        <>
          <AppButton onClick={handleSave} variant="contained" color="primary">
            Save
          </AppButton>
          <AppButton onClick={onClose} variant="outlined">
            Cancel
          </AppButton>
        </>
      }
    >
        <div className="row mt-2">
          <div className="col-md-12 mb-3">
            <FormField
              label="Name"
              value={formTask.name || ""}
              onChange={(e) => handleChange("name", e.target.value)}
            />
          </div>

          <div className="col-md-6 mb-3">
            <FormField
              label="Due Days"
              type="number"
              value={formTask.dueDays || ""}
              onChange={(e) => handleChange("dueDays", +e.target.value)}
            />
          </div>

          
          {/* ✅ isCalendarDate Checkbox */}
          <div className="col-md-6 mb-3">
            <FormControlLabel
              control={
                <Checkbox
                  checked={!!formTask.isCalendarDate}
                  onChange={(e) =>
                    handleChange("isCalendarDate", e.target.checked)
                  }
                />
              }
              label="Calendar Date"
            />
          </div>

          <div className="col-12 mb-3">
            <FormField
              label="Description"
              multiline
              minRows={2}
              value={formTask.description || ""}
              onChange={(e) => handleChange("description", e.target.value)}
            />
          </div>

          <div className="col-md-6 mb-3">
            <ClioTaskAssigneeSelect
              value={formTask.assignee || ""}
              onChange={(assignee) => handleChange("assignee", assignee)}
              users={users}
            />
          </div>
        </div>
    </AppDialog>
  );
}
